import React from "react"

const DoctorCard = ({ initials, role, name, phone, mail, when, when_multiple }) => (
  <div className={`m-doctor-card`}>
    <div className="m-doctor-card__initials">
        <span>
         {initials}
        </span>
    </div>

    <div className="m-doctor-card__role">
      {role}
    </div>

    <h4 className="m-doctor-card__name">
      {name}
    </h4>

    {phone && (
      <div className="m-doctor-card__info">
        <img src="/images/doktor/phone.svg" alt="" aria-hidden="true" />
        {phone}
      </div>
    )}

    {mail && (
      <div className="m-doctor-card__info">
        <img src="/images/doktor/mail.svg" alt="" aria-hidden="true" />
        <a href={`mailto:${mail}`}>{mail}</a>
      </div>
    )}

    {when && (
      <div className="m-doctor-card__info">
        <div className="m-doctor-card__columns">
          <div>
            <img src="/images/doktor/time.svg" alt="" aria-hidden="true" />
          </div>
          <div className="left">
              {when}
          </div>
        </div>
      </div>
    )}

    {when_multiple && (
      <div className="m-doctor-card__info m-doctor-card__info--extended">

        <div className="m-doctor-card__columns">
          <div>
            <img src="/images/doktor/time.svg" alt="" aria-hidden="true" />
          </div>
          <div class="left">
            {when_multiple.map((when, key) => (
              <div className="key" key={key}>
                  {when.key}
              </div>
            ))}
          </div>
          <div>
            {when_multiple.map((when, key) => (
              <div className="value" key={key} dangerouslySetInnerHTML={{ __html: when.value }}/>))}
          </div>
        </div>
      </div>
    )}

  </div>
)

export default DoctorCard
